// extracted by mini-css-extract-plugin
export default {"deviceButton":"ToggleBackgroundEffectsButton_deviceButton__Im71n","icon":"ToggleBackgroundEffectsButton_icon__WNYrT"};